// What every Get Paid hook receives from the façade (useGetPaid).
import type { useApp } from "@/hooks/use-app-context";
import type { useToast } from "@/hooks/use-toast";

type AppContextValue = ReturnType<typeof useApp>;

export type GetPaidT = AppContextValue["t"];
export type GetPaidUser = AppContextValue["user"];
export type GetPaidToast = ReturnType<typeof useToast>["toast"];

export interface GetPaidBase {
  t: GetPaidT;
  user: GetPaidUser;
  toast: GetPaidToast;
}

export interface MoneyFormat {
  locale: string;
  currency: string;
}

export const isAdminOrSuper = (role: string | undefined) => role === "admin" || role === "super_admin";
